import PropTypes from 'prop-types';
import { screenSizes } from '../../../utils';
import './Image.scss';

const Image = (props) => {
  const {
    alt,
    desktopImage,
    tabletImage,
    mobileImage,
    extendClass = '',
    extendTestId = '',
  } = props;
  const imgTestId = extendTestId ? `${extendTestId}-img` : 'img';

  return (
    desktopImage && (
      <picture>
        <source media={`(min-width: ${screenSizes.screenSm}px)`} srcSet={desktopImage} />
        <source
          media={`(min-width: ${screenSizes.screenXs}px)`}
          srcSet={tabletImage || desktopImage}
        />
        <img
          src={mobileImage || desktopImage}
          alt={alt}
          data-testid={imgTestId}
          className={`img-responsive ${extendClass}`}
        />
      </picture>
    )
  );
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  desktopImage: PropTypes.string.isRequired,
  tabletImage: PropTypes.string,
  mobileImage: PropTypes.string,
  extendTestId: PropTypes.string,
};

export default Image;
